const BASE = process.env.REACT_APP_ALI_URL;

export async function searchProducts(keyword = "", category = "", page = 1) {
  const params = new URLSearchParams({
    keyWord: keyword,
    categoryId: category,
    pageIndex: page.toString(),
    local: "en_US",
    countryCode: "NG",
    currency: "NGN",
    pageSize: "30"
  });

  const res = await fetch(`${BASE}products/search/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    body: params
  });

  return res.json();
}


export async function getProductDetail(productId) {
  const res = await fetch(`${BASE}products/${productId}/`);
  return res.json();
}

export async function getShipping(productId, sku_id, ship_to = "NG") {
  const res = await fetch(`${BASE}products/${productId}/shipping/?sku_id=${sku_id}&ship_to=${ship_to}`);
  return res.json();
}

export async function getAliCategories() {
  const res = await fetch(`${BASE}products/categories/`);
  return res.json();
}
// export async function getAliCategories() {
//   const res = await fetch(`http://localhost:8000/aliapi/products/categories/`);
//   return res.json();
// }
